import request from '@/utils/request'

//  分页查询生产订单
export function getPlanOrders(data) {
  return request({
    url: 'v3/manager/qiwei/pageOrder',
    method: 'post',
    data
  })
}

// 上传生产计划excel文件
export function uploadExcel(params) {
  var formData = new FormData()
  formData.append('file', params.raw)
  return request({
    url: '/v3/manager/qiwei/upload?test=false',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}


//  根据生产订单号查询生产计划
export function getPlanList(orderNo) {
  return request({
    url: 'v3/manager/qiwei/orderPlanList?orderNo='+ orderNo,
    method: 'post',
    data: {}
  })
}


// 计划日历
export function getPlanCalendar(data) {
  return request({
    url: 'v3/manager/qiwei/planCalendar',
    method: 'post',
    data
  })
}

// 生产车间列表
export function getProduceShopList() {
  return request({
    url: 'v3/manager/qiwei/produceShopList',
    method: 'post',
    data: {}
  })
}

// 删除计划
export function deletePlan(id) {
  return request({
    url: 'v3/manager/qiwei/deletePlan?id='+ id,
    method: 'post',
    data: {}
  })
}


// 销售单号列表
export function getOrderNoList (data) {
	return request({
    url: 'v3/manager/qiwei/orderNoList', method: 'post', data
  })
}

// 产品选项列表
export function getProductNoList (data) {
	return request({
    url: 'v3/manager/qiwei/productNoList', method: 'post', data
  })
}

// 客户选项列表
export function getCustomerPoNoList (data) {
	return request({
    url: 'v3/manager/qiwei/customerPoNoList', method: 'post', data
  })
}